import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import FilterComp from "../../common/filter-comp.vue";
import DisplayTextData from "@/components/common/display-text-data.vue";
import ReadOnlyDialog from "@/components/common/read-only-dialog.vue";
import receiveService from "./receive-srvice";
import utility from "@/shared/utility";
import ChangeLpn from "../change-lpn-comp.vue";
import CommonDialog from "@/components/common/common-dialog.vue";
import RouteDiscrepancyComp from "../route-discrepancy-comp.vue";
import moment from "moment";
import PrinterDetails from "@/components/common/printer-details.vue";
import ReadMore from "@/components/common/read-more.vue";
import CommonCommentDisplay from "@/components/common/common-comments-display.vue";
import Utility from "../../../shared/utility";
import commonApiService from "@/components/common/js/common-api-service";
export default {
  data() {
    return {
      userId: EncryptUtility.localStorageDecrypt("userID"),
      actionList: [],
      favouriteList: [],
      lpnData: {},
      mainPage: "",
      subPage: "",
      backSlash: true,
      showMessage: false,
      isSubmitting:false,
      showComments: false,
      showSeialDialog: false,
      showSerialMessage: "There is a mismatch in the Serial Number Entered.",
      messageContent: "",
      messageEnd: "",
      tagErrorMessage: "",
      displayCommentData: [],
      messageStart: "",
      pageUrl: "",
      showAdd: false,
      commentsObj: "",
      validateNum: false,
      showDialog: false,
      showSerialNumDialog: false,
      serialDialogTitle: "Serial Number Details",
      message: "",
      searchLineItem: "",
      commentsData: "",
      detailsKey: 0,
      receiveType: "",
      detailsData: false,
      duplicateCheck:true,
      duplicateCheckMsg:"ICCID, ESN, Serial, Revision and BCN must be unique.",
      showDuplicateDialog: false,
      stateData: [],
      showDetails: true,
      validateTag: false,
      showStateDrop: false,
      labelValue: true,
      showChangeLpn: false,
      resetLocation: "",
      displayArrayData: [],
      receivingObProblem: [],
      receivingCondition: [],
      serialDisplayArray: [],
      showPackingTextbox: false,
      disableSerial: false,
      menu1: false,
      showVendor: false,
      showErrorPopup: false,
      newLPNVal: "",
      kyndrylErrorPopup: false,
      labelPrintBit: false,
      searchLPNRule: [
        (v) => (v || "").length <= 39 || "Max Length of 39 character",
        (v) => !!v || "Field is required",
        (value) =>
          /^[0-9]{1,3}(?:-[0-9]{3})*$/.test(value) ||
          "Enter a correct format: 000-000-000-000",
      ],
      showBillMessage:
        "You did not enter an Inbound Waybill Number. Accept Anyway?",
      serialList: [],
      searchPartNum: "",
      lableSwitchValue: true,
      lastField:"",
      discrepancy: {
        ProjKey: "",
        OrdNo: "",
        OrdType: "",
        PackSlip: "",
        WayBill: "",
        Reference: "",
        Comments: "",
        LPN: "",
        BinKey: "",
        UserKey: "",
        lbl_size: "",
        printer_type: "",
        Company: "",
        First: "",
        Last: "",
        Address1: "",
        Address2: "",
        City: "",
        State: "",
        Zip: "",
        Country: "217",
        showBCN: false,
        Phone: "",
        PartDetails: [],
        primaryLabelSize:
          EncryptUtility.localStorageDecrypt("primaryLabelSize"),
        primaryName: EncryptUtility.localStorageDecrypt("primaryName"),
        reason: "",
        emptyBox: false,
        unknownPartFlag: false,
        description: "",
      },
      RoutePartList: [],
      partResultList: [],
      disableIccid: false,
      disableEsn: false,
      showPartNum: false,
      factoryBtnsArray: [
        { label: "No", disabled: false },
        { label: "New", disabled: false },
        { label: "FG-A", disabled: false },
      ],
      CraBtnsArray: [
        { label: "No", disabled: false },
        { label: "Yes", disabled: false },
      ],
      showDiscrepancyDialog: false,
      discrepancyDisplayArrayData: [],
      showDiscrepancyDetails: true,
      showWarrentyData: false,
      projectName: "",
      lpnObj: {},
      lineItemKey: "",
      lineObj: {
        UserId: 0,
        so_key: 0,
        line_id: 0,
        show_closed: true,
        PageNumber: 1,
        DiscrepancyTag: "",
      },
      countryData: [],
      showPartDetails: false,
      showSerialNum: false,
      reasonList: [],
      detailsList: [],
      commonHeader: [],
      tableItems: [],
      promptInfo: [],
      required: [(v) => !!v || "Field is required"],
      max36Regrex: [
        (v) => !!v || "Field is required",
        (v) => v.length <= 36 || "Must be 36 characters or less",
        (v) => /^[a-zA-Z0-9/._ -]*$/.test(v) || "Invalid characters used",
      ],
      dscTagRule: [
        (v) => !!v || "Field is required",
        (v) => v.length <= 36 || "Must be 36 characters or less",
        (v) =>
          /^[0-9a-zA-Z-]*$/.test(v) ||
          "Only letters, numbers, and hyphens are allowed",
      ],
      esnRule: [
        (v) => !!v || "Field is required",
        (v) => v.length <= 36 || "Must be 36 characters or less",
        (v) =>
          /^([a-zA-Z0-9/._ -]+|([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2}))$/.test(
            v
          ) ||
          "Invalid format: Only alphanumeric with / . _ - or a MAC address allowed",
      ],
      iccidRule: [
        (v) => !!v || "Field is required",
        (v) =>
          v.length === 19 ||
          v.length === 20 ||
          "Must be 19 or 20 characters long",
        (v) =>
          /^[a-zA-Z0-9/._ -]+$/.test(v) ||
          "Only letters, numbers, / . _ - are allowed",
      ],
      max25Rule: [
        (v) => v?.length <= 25 || "Must be 25 characters or less",
        (v) => !!v || "Field is required",
      ],
      WayBillRule: [(v) => v?.length <= 25 || "Must be 25 characters or less"],
      revisonRule: [
        (v) => !!v || "Field is required",
        (v) => v?.length <= 20 || "Maximum 20 characters allowed",
        (v) =>
          /^[a-zA-Z0-9/._ -]+$/.test(v) ||
          "Only letters, numbers, / . _ - are allowed",
      ],
      firmWareRule: [
        (v) => !!v || "Field is required",
        (v) => v?.length <= 20 || "Maximum 20 characters allowed",
        (v) =>
          /^[a-zA-Z0-9/._ -]+$/.test(v) ||
          "Only letters, numbers, / . _ - are allowed",
      ],
      qtyRule: [
        (v) => parseInt(v) > 0 || "Field should be greater than 0",
        (v) =>
          parseInt(v) < 2147483647 || "Field should be less than 2,147,483,647",
      ],
      partNum: "",
      showFactoryMsg: false,
      showCraMsg: false,
      partDesc: "",
      unitInfo: {
        user_key: "",
        PoSo: "",
        ProjKey: "",
        OrdNo: "",
        LineId: "",
        PartKey: "",
        Session: "",
        WayBill: "",
        PackSlip: "",
        Vendor_Reference: "",
        Qty: 1,
        BCN: "",
        SerialNo: "",
        ESN: "",
        ICCID: "",
        LPN: "",
        BinKey: "",
        DNC: 0,
        New_IT: 0,
        CRA: false,
        ConditionKey: 0,
        ObservedKey: 0,
        nfkey: "0",
        nskey: "0",
        MSR: "",
        Firm_Rev: "",
        lbl_size: "",
        printer_type: "",
        dsc_tag: "",
        WarrantyEndDate: "",
      },
      disableCraIndex: null,
      disableBtnFactoryIndex: null,
      showWaybillDialog: false,
      partNumHeader: [
        {
          text: "Part#",
          value: "Part#",
          class: "primary customwhite--text",
        },
        {
          text: "Identifier",
          value: "Identifier",
          class: "primary customwhite--text",
        },
        {
          text: "Qty",
          value: "Qty",
          class: "primary customwhite--text",
        },
        {
          text: "Action",
          value: "action",
          class: "primary customwhite--text",
        },
      ],
      detailsHeader: [
        {
          text: "Line#",
          value: "Line#",
          class: "primary customwhite--text",
        },
        {
          text: "Part#",
          value: "Part#",
          class: "primary customwhite--text",
        },
        {
          text: "Warehouse",
          value: "Warehouse",
          class: "primary customwhite--text",
        },
        {
          text: "Location",
          value: "Location",
          class: "primary customwhite--text",
        },
        {
          text: "Grade",
          value: "Grade",
          class: "primary customwhite--text",
        },
        {
          text: "Open",
          value: "Open",
          class: "primary customwhite--text",
        },
        {
          text: "Marked For Resolution",
          value: "dsc_qty",
          class: "primary customwhite--text",
        },
      ],
      disableEmpty: true,
      disableUnknownPart: true,
      focusField: "waybill", // Initial field to focus
      sequence: [
        { field: "waybill", condition: true },
        { field: "packing", condition: this.showPackingTextbox },
        { field: "vendor", condition: this.showVendor },
        { field: "bcn", condition: this.showBCN },
        { field: "condition", condition: this.receivingCondition?.length > 0 },
        { field: "serial", condition: this.promptInfo?.serial_bit },
        { field: "esn", condition: this.promptInfo?.esn_bit },
        { field: "iccid", condition: this.promptInfo?.iccid_bit },
        { field: "warranty", condition: this.showWarrentyData },
        { field: "revision", condition: this.promptInfo?.msr_bit },
        { field: "firmware", condition: this.promptInfo?.firm_bit },
        { field: "qty", condition: true },
        { field: "discrepancy", condition: true },
        { field: "factory", condition: this.promptInfo?.dnc_rcv },
        { field: "cra", condition: this.promptInfo?.cra_rcv },
        { field: "submit", condition: true },     
      ],
      errorText: "",
      finalSubmitForLPNChange: {
        ProjKey: 0,
        OrdNo: 0,
        OrdType: "",
        PackSlip: "",
        WayBill: "",
        LPN: "",
        BinKey: 0,
        UserKey: 0,
        lbl_size: "",
        printer_type: "",
        Company: "",
        First: "",
        Last: "",
        Address1: "",
        Address2: "",
        City: "",
        State: "",
        Zip: "",
        Country: "",
        Phone: "",
        line_key: 0,
        PartDetails: [],
      },
      partObj: {
        PartNum: "",
        PartDesc: "",
        Qty: 0,
        Unit: "",
        ReasonKey: 0,
        CID: 0,
      },
      PartDetails: [],
      printDisable: false,
      printerConfigured: false,
      showPrimary: true,
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    this.detailsKey = atob(this.$route.path.replace("/", "")?.split("/")[2]);
    this.receiveType = this.$route.path.replace("/", "")?.split("/")[1];
    this.lineItemKey = atob(this.$route.path.replace("/", "")?.split("/")[3]);
    let kyndryl = atob(this.$route.path.replace("/", "")?.split("/")[4]);
    this.isKyndryl = kyndryl == 1 ? true : false;
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    if (this.receiveType === "SO" || this.receiveType === "PO") {
      this.mainPage = "Receiving";
      this.favouriteList = data.favouriteList;
      this.pageUrl = "receiving";
      this.subPage = `${this.receiveType} Receiving Details`;
    }
    if (EncryptUtility.localStorageDecrypt("LabelSwitchValue") !== null && EncryptUtility.localStorageDecrypt("LabelSwitchValue") !== undefined) {
      this.labelValue = JSON.parse(EncryptUtility.localStorageDecrypt("LabelSwitchValue"));
      this.lableSwitchValue = this.labelValue;
    }
    this.onChangeLabelFunction(this.labelValue);
    if (this.lableSwitchValue) {
      if (EncryptUtility.localStorageDecrypt("primaryLabelSize") !== null && EncryptUtility.localStorageDecrypt("primaryLabelSize") !== undefined) {
        this.printDisable = false;
        this.printerConfigured = false;
      } else {
        this.printDisable = true;
        this.printerConfigured = true;
        let Alert = {
          type: "error",
          isShow: true,
          message: "Receiving/Inventory Printer is not configured, please configure printer",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
      }
    }   
  },
  computed: {
    computedDateFormattedMomentjs() {
      return this.unitInfo.WarrantyEndDate
        ? moment(String(this.unitInfo.WarrantyEndDate)).format("MM/DD/YYYY")
        : "";
    },
  },
  async mounted() {
    this.receiveType == "SO"
      ? (this.unitInfo.PoSo = "SO")
      : (this.unitInfo.PoSo = "PO");
    this.unitInfo.LineId = this.lineItemKey;
    this.lineObj.DiscrepancyTag =
      this.getDiscrepancyTagDetails()?.DiscrepancyTag;
    this.unitInfo.lbl_size = EncryptUtility?.localStorageDecrypt("primaryLabelSize");
    let searchInfo=EncryptUtility.localStorageDecrypt("soSearchObj");
    this.unitInfo.WayBill= searchInfo ? JSON.parse(searchInfo)?.Waybill :"";
    this.unitInfo.printer_type = this.primaryName;
    this.unitInfo.dsc_tag = this.getDiscrepancyTagDetails()?.DiscrepancyTag;
    this.commentsObj = {
      UserId: this.userId,
      type: this.receiveType,
      order_id: this.detailsKey,
      pass: 2,
    };
    try {
      // Get and parse LPN details
      // Prepare and fetch line items
      await this.fetchLineItems();
    } catch {
      return null;
    }
    this.displayArrayData = JSON.parse(
      EncryptUtility.localStorageDecrypt("receiveDetailsData")
    );
    this.displayCommentData = this.displayArrayData.filter(
      (item) =>
        item.label === "Problem Description" || item.label === "Comments"
    );
    this.displayArrayData = this.displayArrayData.filter(
      (item) =>
        item.label !== "Problem Description" && item.label !== "Comments"
    );
    this.orderNum = this.displayArrayData[2].value;
    const lpnDetails = this.getLpnDetails();
    if (!lpnDetails) return;
    // Update component state with LPN data
    this.updateLpnState(lpnDetails);
  },
  methods: {
    getDiscrepancyTagDetails() {
      try {
        const key = this.receiveType === "SO" ? "soSearchObj" : "poSearchObj";
        const decryptedData = EncryptUtility?.localStorageDecrypt(key);
        return decryptedData ? JSON.parse(decryptedData) : {};
      } catch {
        return null;
      }
    },
    getLpnDetails() {
      try {
        return JSON.parse(
          EncryptUtility.localStorageDecrypt("receivelpnDetails")
        );
      } catch {
        return null;
      }
    },
    // on Click of factory buttons
    onClickDisableBtns(index, label, loc) {
      this.isKyndryl && !this.validateNum ?this.validateSerialNo(): "";
      loc == "Factory" ? this.focusNextField("factory") : this.focusNextField("cra");
      loc == "Factory" ? (this.showFactoryMsg = false) : "";
      loc == "CRA" ? (this.showCraMsg = false) : "";
      loc == "Factory"
        ? (this.disableBtnFactoryIndex = index)
        : (this.disableCraIndex = index);
      loc == "Factory" && index == 2
        ? ((this.unitInfo.DNC = 1), (this.unitInfo.New_IT = 1))
        : "";
      loc == "Factory" && index == 1 ? (this.unitInfo.DNC = 1) : "";
      loc == "CRA" && index == 1 ? (this.unitInfo.CRA = true) : "";
    },
    updateLpnState(lpnObj) {
      this.lpnObj = lpnObj;
      Object.assign(this, {
        showReceiveLPN: Boolean(lpnObj.lpn),
        showLpnVal: lpnObj.lpn || "",
        showReceiveStaging: Boolean(lpnObj.bin),
        showReceiveStagingVal: lpnObj.bin || "",
      });
      this.projectName = this.lpnObj.projectName;
      this.unitInfo.Session = this.lpnObj.sessionId;
      this.unitInfo.ProjKey = this.lpnObj.proj_key;
      this.unitInfo.LPN = this.lpnObj.lpn;
      this.unitInfo.BinKey = this.lpnObj.stage_bin_key;
    },
    togglePackingTextbox() {
      this.showPackingTextbox = !this.showPackingTextbox;
      const packingItem = this.sequence?.find(
        (item) => item.field === "packing"
      );
      if (packingItem) {
        packingItem.condition = this.showPackingTextbox;
      }
    },
    // Toggle Vendor Reference visibility and update sequence
    toggleVendorReference() {
      this.showVendor = !this.showVendor;
      const vendorItem = this.sequence?.find((item) => item.field === "vendor");
      if (vendorItem) {
        vendorItem.condition = this.showVendor;
      }
    },
    // Toggle Warranty Date visibility and update sequence
    toggleWarrantyDate() {
      this.showWarrentyData = !this.showWarrentyData;
      const warrantyItem = this.sequence?.find(
        (item) => item.field === "warranty"
      );
      if (warrantyItem) {
        warrantyItem.condition = this.showWarrentyData;
      }
    },
    async fetchOrderDetails() {
      const service =
        this.receiveType === "SO"
          ? receiveService.getRecevingSalesOrderDetails.bind(receiveService)
          : receiveService.getRecevingPurchaseOrderDetails.bind(receiveService);
      return await service("get", this.userId, this.detailsKey);
    },
    async fetchLineItems() {
      try {
        // Update lineObj with the correct keys
        this.lineObj = {
          ...this.lineObj,
          UserId: this.userId,
          line_id: this.lineItemKey,
          ...(this.receiveType === "SO"
            ? { so_key: this.detailsKey }
            : { po_key: this.detailsKey }),
        };

        // Get the appropriate service method
        const serviceMethod =
          this.receiveType === "SO"
            ? receiveService.getRecevingSalesOrderLineItems.bind(receiveService)
            : receiveService.getRecevingPurchaseOrderLineItems.bind(
                receiveService
              );

        // Call the service method with the required parameters
        const displayData = await serviceMethod("post", this.lineObj, false);
        this.labelPrintBit = displayData?.Result?.PromptInfo[0]?.lbl_print_bit;
        this.showComments = true;
        this.commentsData={
          NotesInfo:displayData?.Result?.NotesInfo,
          CommentsInfo:displayData?.Result?.CommentsInfo,
        };
        this.serialList = displayData.Result.SerialInfo;
        this.detailsList = displayData.Result.LineInfo;
        this.promptInfo = displayData.Result.PromptInfo[0];
        this.receivingObProblem = displayData.Result.ReceivingProbInfo;
        this.receivingCondition = displayData.Result.ReceivingConInfo;
        this.showBCN = this.promptInfo.bcn_bit;
        this.showSerialNum = this.promptInfo?.serial_bit;
        this.isKyndryl = this.promptInfo?.IsKyndryl == 1 ? true : false;
        // Dynamically set the sequence array based on the flags
        this.sequence = [
          { field: "waybill", condition: true },
          { field: "packing", condition: this.showPackingTextbox },
          { field: "vendor", condition: this.showVendor },
          { field: "warranty", condition: this.showWarrentyData },
          { field: "condition",condition: this.receivingCondition?.length > 0,},
          { field: "bcn", condition: this.promptInfo?.bcn_bit && !this.promptInfo?.auto_bcn_bit },
          { field: "serial", condition: this.promptInfo?.serial_bit },
          { field: "esn", condition: this.promptInfo?.esn_bit },
          { field: "iccid", condition: this.promptInfo?.iccid_bit },          
          { field: "revision", condition: this.promptInfo?.msr_bit },
          { field: "firmware", condition: this.promptInfo?.firm_bit },
          {
            field: "qty",
            condition: !(
              this.promptInfo?.bcn_bit ||
              this.promptInfo?.serial_bit ||
              this.promptInfo?.esn_bit ||
              this.promptInfo?.iccid ||
              (this.promptInfo.dsc_qty > 0 &&
                this.promptInfo.dsc_qty == this.detailsList[0].Open &&
                this.detailsList[0].Open == 1)
            ),
          },
          {
            field: "discrepancy",
            condition:
              this.promptInfo.dsc_qty > 0 &&
              this.promptInfo.dsc_qty == this.detailsList[0].Open,
          },
        { field: "factory", condition: this.promptInfo?.dnc_rcv },
        { field: "cra", condition: this.promptInfo?.cra },
        { field: "submit", condition: true },
        ];
      } catch (error) {
        this.detailsList = [];
        throw error;
      }
    },
    onClickDialogCancelWayBill() {
      this.showWaybillDialog = false;
    },
    onClickDialogOkWaybill() {
      this.unitInfo.WayBill = "MISSING WAYBILL";
      this.showWaybillDialog = false;
    },
    async fetchOrders(searchType, pageNum = 1) {
      this.searchType = searchType;
      let requestObj;
      if (searchType === "search") {
        requestObj = {
          UserId: this.userId,
          SearchStr: this.textSearch,
          projKey: this.lpnObj.proj_key,
          show_closed: this.includeClosed ? 1 : 0,
          PageNumber: pageNum,
        };
      } else {
        requestObj = this.receiveType === "SO" ? this.soObj : this.poObj;
        requestObj.userId = this.userId;
        requestObj.ProjKey = this.lpnObj.proj_key;
        requestObj.show_closed = this.includeClosed ? 1 : 0;
        requestObj.PageNumber = pageNum;
      }
      let serviceMethod =
        searchType === "search"
          ? this.receiveType === "SO"
            ? receiveService.postSalesOrderSearch.bind(receiveService)
            : receiveService.postPurchaseOrderSearch.bind(receiveService)
          : this.receiveType === "SO"
          ? receiveService.postSalesOrderAdvance.bind(receiveService)
          : receiveService.postPurchaseOrderAdvance.bind(receiveService);
      let response = await serviceMethod("post", requestObj, false);
      this.showTable = true;
      this.tableData = response?.Resultset || [];
      this.tableData.forEach((element) => {
        element.order_date = utility.displayDateFormat(element.order_date);
      });
      this.totalRecords = response.TotalRecords;
      this.pageCount = response.TotalPages;
    },
    // Usage:
    async onClickSearch(pageNum) {
      await this.fetchOrders("search", pageNum);
    },
    async onClickFind(pageNum) {
      await this.fetchOrders("filter", pageNum);
    },
    onPageChange(pageNumber) {
      this.searchType == "filter"
        ? this.onClickFind(pageNumber)
        : this.onClickSearch(pageNumber);
    },
    onClickReceiveStagingFunction() {
      this.$router.push(`/receiving/${this.receiveType}`);
    },
    async onClickRouteToDiscrepancy() {
      this.showDiscrepancyDialog = true;
    },
    closeChangeLpnDialog(lpn) {
      if (lpn) {
        this.showLpnVal = lpn;
        this.lpnObj.lpn = lpn;
        this.unitInfo.LPN = lpn;
        EncryptUtility.localStorageEncrypt(
          "receivelpnDetails",
          JSON.stringify(this.lpnObj)
        );
      }
      this.showChangeLpn = false;
    },
    onClickReceiveLPNFunction() {
      this.showChangeLpn = true;
      this.dialogType = "LPN";
    },
    onChangeLabelFunction(value) {
      this.lableSwitchValue = value;
      EncryptUtility.localStorageEncrypt('LabelSwitchValue', JSON.stringify(this.lableSwitchValue));
    },
    receiveQuickVerificationFunction() {
      this.showChangeLpn = true;
      this.dialogType = "Verify";
    },
    onClickReceiveResetFunction(value) {
      this.showDialog = true;
      this.resetLocation = value;
      this.message = `Are you sure you want to close this receipt? You will lose any unsubmitted data?`;
    },
    onClickDialogOk() {
      this.showDialog = false;
      this.resetLocation == "reset"
        ? this.$router.push("/receiving")
        : this.redirectLogic();
    },
    onClickDialogCancel() {
      this.showDialog = false;
    },
    redirectLogic() {
      EncryptUtility.localStorageDecrypt("totalRecordsCounts") == 1
        ? this.$router.push(`/receiving-list/${this.receiveType}`)
        : this.$router.go(-1);
    },
    onClickShowAllItems() {
      this.$router.go(-1);
    },
    closeDiscrepancyDialog() {
      this.showDiscrepancyDialog = false;
    },
    async onClickSubmitUnitInfo() {
      this.disableSerial=false;
      this.isSubmitting = true;
      const { ICCID, ESN, SerialNo, BCN, Firm_Rev } = this.unitInfo;
      const values = [ICCID, ESN, SerialNo, BCN, Firm_Rev];

      // Check for duplicate values and set focus to the appropriate field if found
      if (values?.some((val, index) => values?.indexOf(val) !== index && val)&& this.duplicateCheck) {     
        this.showDuplicateDialog = true;
        // Find the duplicate value and set focus to corresponding field
        const duplicateVal = values.find((val, index) => values.indexOf(val) !== index && val);
        if (duplicateVal === ICCID) this.focusField = "iccid";
        else if (duplicateVal === ESN) this.focusField = "esn";
        else if (duplicateVal === SerialNo) this.focusField = "serial";
        else if (duplicateVal === BCN) this.focusField = "bcn";
        else if (duplicateVal === Firm_Rev) this.focusField = "firmware";
        
        return;
      }

      this.unitInfo.user_key = this.userId;
      this.unitInfo.PoSo = this.receiveType == "SO" ? "S" : "P";
      this.unitInfo.LineId = this.lineItemKey;
      this.unitInfo.PartKey = "";
      this.unitInfo.ObservedKey = 0;
      // Validate ProjKey
      if (!this.unitInfo.ProjKey || this.unitInfo.ProjKey === "" || this.unitInfo.ProjKey === 0) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "Project Key is required and cannot be blank",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.focusField = "waybill";
        this.isSubmitting = false;
        return;
      }
      // Check waybill
      if (this.unitInfo.WayBill == "") {
        this.showWaybillDialog = true;
        this.focusField = "waybill";
        return;
      }
      // Check discrepancy
      if (
        this.promptInfo.dsc_qty > 0 &&
        this.promptInfo.dsc_qty == this.detailsList[0].Open
      ) {
        this.onBlurValidate();
      }
      this.disableCraIndex == null || this.disableCraIndex == undefined
        ? (this.showCraMsg = true)
        : "";
      this.disableBtnFactoryIndex == null ||
      this.disableBtnFactoryIndex == undefined
        ? (this.showFactoryMsg = true)
        : "";
      let validate =
        this.$refs.unitForm.validate() &&
        !this.showWaybillDialog &&
        !(this.promptInfo?.dnc_rcv && this.showFactoryMsg) &&
        !(this.promptInfo?.cra && this.showCraMsg) &&
        !this.validateTag;
      if (validate) {
        this.unitInfo.OrdNo = this.orderNum;
        let postObj = {
          UserId: this.userId,
          json: JSON.stringify(this.unitInfo),
        };
        let resp = await receiveService.submitReceiveLineItem(
          "post",
          postObj,
          false
        );
        if (!resp) {
          this.isSubmitting = false;
          this.promptInfo?.serial_bit?this.focusField="serial":this.focusField="waybill";
        }
        if (resp?.Info?.HeaderInfo[0].status == "OK") {
          let Alert = {
            type: "success",
            isShow: true,
            message: "Receiving details submitted successfully",
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.promptInfo.serial_bit = 0;
          this.promptInfo.bcn_bit = 0;
          this.focusField = !this.promptInfo?.auto_bcn_bit ? "BCN" : "serial";
          this.showBCN = false;
          this.showSerialNum = false;
          this.$nextTick(() => {
            this.showBCN = true;
            this.showSerialNum = true;
            this.fetchLineItems();
          });
          this.isSubmitting = false;
        }
        if (resp?.Info?.HeaderInfo[0].status == "OK" && this.lableSwitchValue) {
          if(this.labelPrintBit){
            resp.Info.LabelInfo
              ? PrinterDetails.printLabelDataArray(
                  resp.Info.LabelInfo,
                  EncryptUtility.localStorageDecrypt("primaryName")
                )
              : "";
          }
        }
        this.detailsList = resp.Info.LineInfo;
        if (resp?.Info.HeaderInfo[0].set_ui == 2) {
          this.showMessage = true;
          this.messageStart = resp?.Info.HeaderInfo[0].start_msg;
          this.messageContent = resp?.Info.HeaderInfo[0].content_msg;
          this.messageEnd = resp?.Info.HeaderInfo[0].end_msg;
          this.clearUnitInfo(false);
        } else {
          this.showMessage = false;
          this.redirectLogic();
        }      
      }   else {
        utility.showNoDataToast("Please fill all required fields");
        this.unitInfo?.ESN === ""?this.focusField = "esn": "";
        this.unitInfo?.ICCID === ""?this.focusField = "iccid": "";
        this.unitInfo?.SerialNo === ""?this.focusField = "serial": "";
        this.unitInfo?.BCN === "" && this.showBCN && !this.promptInfo?.auto_bcn_bit? this.focusField = "bcn": "";
        this.unitInfo?.Firm_Rev === ""?this.focusField = "firmware": "";
        this.isSubmitting = false;
        this.disableCraIndex = null;
        this.disableBtnFactoryIndex = null;
        return ""

      }
    },
    clearUnitInfo(clearAll) {
      this.isSubmitting = false;
      this.duplicateCheck = true;
      this.$refs?.iccidForm?.resetValidation();
      this.$refs.unitForm?.resetValidation();
      this.disableSerial = false;
      this.disableCraIndex = null;
      this.disableBtnFactoryIndex = null;
      this.showFactoryMsg = false;
      this.showCraMsg = false;
      this.disableIccid = false;
      this.validateNum = false;
      this.disableEsn = false;
      if (clearAll) {
        this.focusField = "waybill";
        this.unitInfo = {
          PartKey: "",
          WayBill: "",
          PackSlip: "",
          Vendor_Reference: "",
          Qty: 1,
          BCN: "",
          SerialNo: "",
          ESN: "",
          ICCID: "",
          LPN: "",
          BinKey: "",
          DNC: 0,
          New_IT: 0,
          CRA: false,
          ConditionKey: 0,
          ObservedKey: 0,
          nfkey: "0",
          nskey: "0",
          MSR: "",
          Firm_Rev: "",
          dsc_tag: "",
          WarrantyEndDate: "",
        };
      } else {
        this.unitInfo = {
          ...this.unitInfo,
          Qty: 1,
          BCN: "",
          SerialNo: "",
          ESN: "",
          ICCID: "",
          DNC: 0,
          New_IT: 0,
          CRA: false,
          nfkey: "0",
          nskey: "0",
          MSR: "",
          Firm_Rev: "",
          dsc_tag: "",
        };
        if(this.lastField!="condition"){
        this.focusNextField("condition");
      }
      else{
        this.focusNextField("waybill");
      }
    }
    },
    async onBlurValidate() {
      this.focusNextField("discrepancy");
      let tagObj = {
        UserId: this.userId,
        so_key: this.detailsKey,
        line_id: this.lineItemKey,
        tag: this.unitInfo.dsc_tag,
      };
      let res = await receiveService.onBlurDiscrepancy("post", tagObj, true);
      if (!res) {
        this.tagErrorMessage = "This field is invalid";
      } else {
        this.tagErrorMessage = "";
        this.validateTag = false;
      }
    },
    async onValidateUnitValues(pass, value) {
      let isValid = false;
      // Validation checks with early returns
      if (pass === 1 && this.unitInfo.SerialNo.length === 0) {
        utility.showNoDataToast("Serial Number is empty");
        return;
      } else if (pass === 1 && this.unitInfo.SerialNo.length !== 0) {
        this.isKyndryl?this.validateSerialNo(): this.focusNextField("serial");
      }
      if (pass === 2 && this.unitInfo.BCN.length === 0) {
        utility.showNoDataToast("BCN is empty");
        return;
      }
      if (pass === 3 && this.unitInfo.ESN.length === 0) {
        utility.showNoDataToast("ESN is empty");
        return;
      }
      if (pass === 4 && this.unitInfo.ICCID.length === 0) {
         isValid = this.$refs?.iccidForm?.validate();
        utility.showNoDataToast("ICCID is empty");
        return;
      }
      if (!isValid) {
        return;
      }
      // Prepare the object for API request
      const obj = {
        UserId: this.userId ?? "",
        pass: pass,
        po_so: this.receiveType == "SO" ? "S" : "P",
        order_key: this.detailsKey ?? "",
        line_id: this.lineItemKey ?? "",
        ValidateText: value,
      };
      let resp = await receiveService.postIdentifierValidation(
        "post",
        obj,
        false
      );
      if (resp.Result.Info[0].status === "OK") {
        if (resp.Result.Info[0].setID_UI === 3) {
          this.showSeialDialog = true;
        } else if (resp.Result.Info[0].setID_UI === 2) {
          let data = resp.Result.HeaderInfo[0];
          this.serialDisplayArray = [
            { label: "Project", value: data?.project },
            { label: "Business", value: data?.business },
            {
              label: data?.sono ? "SO Number" : "PO Number",
              value: data?.sono || data?.custpo,
            },
            { label: "RMA", value: data?.rma },
            { label: "Request Number", value: data?.request_number },
            { label: "RITM", value: data?.RITM },
            { label: "Order Number", value: data?.ordno },
            { label: "Customer PO", value: data?.custpo },
            { label: "Order Type", value: data?.order_type },
            { label: "Company", value: data?.name, subValue: data?.company },
            { label: "Note", value: data?.note, readMore: true },
            {
              label: "Problem Description",
              value: data?.prob_desc,
              readMore: true,
            },
          ];
          this.commonHeader = this.detailsHeader;
          this.tableItems = resp.Result.LineInfo;
          this.showSerialNumDialog = true;
          this.unitInfo.SerialNo = "";
          this.$refs?.unitForm?.resetValidation();
        }
        if (pass === 3) {
          this.disableEsn = true;
        }
        if (pass === 4) {
          this.disableIccid = true;
        }
      }
    },
    //Validate Serial Number
    validateSerialNo() {
      if (this.isKyndryl) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        this.axios
            .get("ex/x_kyndryl_scan?serial_number=" + this.unitInfo.SerialNo)
          .then((response) => {
            if (response.status == 200) {
              let responseData = JSON.parse(response.data.body.message);
              let txtError = JSON.parse(responseData?.body?.body);
              if (txtError?.result?.state == undefined) {
                this.errorText = txtError.result;
                this.showErrorPopup = true;
              }
              else
              {
                this.focusNextField("serial");
                this.disableSerial=true;
                this.validateNum=true;
                this.disableCraIndex = null;
                this.disableBtnFactoryIndex = null;
                this.showFactoryMsg = false;
                this.showCraMsg=false;
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              var Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            this.kyndrylErrorPopup = true;
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            this.errorMessage = error.message;
          });
      }
    },
    onClickDialogOkSerialDialog() {
      this.onClickRouteToDiscrepancy();
      this.showSeialDialog = false;
      this.disableSerial = true;
    },
    onClickDialogCancelSerialDialog() {
      this.showSeialDialog = false;
      this.disableSerial = true;
    },
    closeSerialDialog() {
      this.showSerialNumDialog = false;
    },
    clickOKError() {
      this.kyndrylErrorPopup = false;
      this.unitInfo.SerialNo = "";
    },
    onClickOkDuplicateDialog() {
      this.showDuplicateDialog = false;
      this.duplicateCheck = false;
      this.onClickSubmitUnitInfo();
      this.isSubmitting = true;
    },
    onClickCancelDuplicateDialog() {
      this.showDuplicateDialog = false;
      this.isSubmitting = false;
      this.focusNextField("waybill");
      this.duplicateCheck = true;
    },
    focusNextField(currentField) {   // Find the index of the current field in the sequence
      const currentIndex = this.sequence?.findIndex(
        (item) => item.field === currentField
      );

      // Find the last field with a true condition that has a visible textbox
      const activeFields = this.sequence.filter((item) => item.condition);
      const lastVisibleField = activeFields
        .filter((field) => {
          // Check for fields that have visible text inputs
          return [
            "waybill",
            "packing",
            "vendor",
            "warranty",
            "condition",
            "bcn",
            "serial",
            "esn",
            "iccid",
            "revision",
            "firmware",
            "qty",
            "discrepancy",
            "factory",
            "cra",
          ].includes(field.field);
        })
        .pop()?.field;
        this.lastField=lastVisibleField
      // If this is the last visible field with a true condition, focus on submit button
      if (currentField === lastVisibleField) {
        this.focusField = "submit";  
        // Focus on submit button and trigger click
        this.$nextTick(() => {
          const submitButton = this.$refs.submitButton;
          if (submitButton && !this.promptInfo?.cra && !this.promptInfo?.dnc_rcv&& !this.isSubmitting) {
            this.onClickSubmitUnitInfo();
          }
          else if(submitButton && (this.promptInfo?.cra || this.promptInfo?.dnc_rcv)){
            this.focusField = "submit";
          }
        });
        return;
      }
      // Loop through the sequence to find the next field with a true condition
      for (let i = currentIndex + 1; i < this.sequence.length; i++) {
        const nextItem = this.sequence[i];
        if (nextItem.condition) {
          this.focusField = nextItem.field;
          break;
        }
      }
    },
    //LPN num format
    lpnNumFormat(event, num) {
      this.newLPNVal = Utility.formatLPNNumber(event, num);
    },
    //New LPN Submit Call
    async newLPNSubmit() {
      if (this.$refs.newLPNForm.validate()) {
        this.finalSubmitForLPNChange.ProjKey = this.unitInfo.ProjKey;
        this.finalSubmitForLPNChange.OrdNo = this.displayArrayData[0]?.value;
        this.finalSubmitForLPNChange.OrdType = this.unitInfo.PoSo;
        this.finalSubmitForLPNChange.PackSlip = this.unitInfo.PackSlip;
        this.finalSubmitForLPNChange.WayBill = this.unitInfo.WayBill;
        this.finalSubmitForLPNChange.LPN = this.newLPNVal;
        this.finalSubmitForLPNChange.BinKey = this.unitInfo.BinKey;
        this.finalSubmitForLPNChange.UserKey = parseInt(this.userId);
        this.finalSubmitForLPNChange.lbl_size =
          EncryptUtility.localStorageDecrypt("primaryLabelSize");
        this.finalSubmitForLPNChange.printer_type =
          EncryptUtility.localStorageDecrypt("primaryPrinterType");
        this.finalSubmitForLPNChange.Company = "";
        this.finalSubmitForLPNChange.First = "";
        this.finalSubmitForLPNChange.Last = "";
        this.finalSubmitForLPNChange.Address1 = "";
        this.finalSubmitForLPNChange.Address2 = "";
        this.finalSubmitForLPNChange.City = "";
        this.finalSubmitForLPNChange.State = "";
        this.finalSubmitForLPNChange.Zip = "";
        this.finalSubmitForLPNChange.Country = "";
        this.finalSubmitForLPNChange.Phone = "";
        this.finalSubmitForLPNChange.isAutoSubmit = 1;
        this.finalSubmitForLPNChange.line_key = parseInt(
          this.detailsList[0].line_id
        );
        this.partObj.PartNum = this.detailsList[0]["Part#"];
        this.partObj.PartDesc = this.detailsList[0]?.Descrip;
        this.partObj.Qty = 1;
        this.partObj.Unit = this.unitInfo.SerialNo;
        this.partObj.ReasonKey = 0;
        this.partObj.CID = 0;
        this.PartDetails.push(this.partObj);
        this.finalSubmitForLPNChange.PartDetails = this.PartDetails;
        let discrepancyObj = {
          UserId: this.userId,
          json: JSON.stringify(this.finalSubmitForLPNChange),
        };
        let res = await receiveService.postDiscrepancySave(
          "post",
          discrepancyObj,
          false
        );
        if (res && this.lableSwitchValue) {
          res.Info.LabelInfo
          ? PrinterDetails.printLabelDataArray(
              res.Info.LabelInfo,
              EncryptUtility.localStorageDecrypt("primaryName")
            )
          : "";     
        }
        this.closeDialog();
        this.unitInfo.SerialNo = "";
      }
    },
    //Close Error dialog
    closeDialog() {
      this.showErrorPopup = false;
      this.errorTitle = "";
      this.errorMessage = "";
      this.newLPNVal = "";
      this.unitInfo.SerialNo = "";
      this.$refs.newLPNForm.resetValidation();
      this.focusField="serial"
      this.disableSerial = false;
      this.disableCraIndex = null;
      this.disableBtnFactoryIndex = null;
      this.showFactoryMsg = false;
      this.showCraMsg=false;
    },
    async getLPNNumber() {
      let lpnData = await commonApiService.getNextAvailableLPN(
        "get",
        this.userId
      );
      if (lpnData.message !== "NA") {
        this.newLPNVal = lpnData[0]?.lpn;
      }
    },
    checkValidateForm(value) {
      if (this.$refs.iccidForm.validate()) {
        this.focusNextField(value);
      } else {
        this.focusField = value;
      }
    },
    printerDetails(labelPrinter) {
      if (!labelPrinter) {
        this.printDisable = false;
        this.printerConfigured = false;
      } else {
        this.printDisable = true;
        this.printerConfigured = true;
      }
    },
    submit() {
      // Prevent default form submission
      // Actual submission is handled by onClickSubmitUnitInfo
    },
  },
  components: {
    breadcrumbComp,
    FilterComp,
    DisplayTextData,
    ReadOnlyDialog,
    ChangeLpn,
    CommonDialog,
    RouteDiscrepancyComp,
    ReadMore,
    CommonCommentDisplay,
    PrinterDetails,
  },
};
